import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import UserServices from "../../../services/UserServices"; // Ensure this imports the updateUser method
import Swal from "sweetalert2";
import UseEditModal from './UseEditModal';
import Select from 'react-select';
import UserAddModel from "./UserAddModel";
import UserPending from "./UserPending";
import Loader from "../Loader/loader";
import Pagination from "../Pagenation/Pagenation";


const User = () => {
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(true);
  const [gridInsideModal, setGridInsideModal] = useState(false);
  const [sort, setSort] = useState(100); // Number of items per page
  const activePag = useRef(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [activeUsers, setActiveUsers] = useState([]);
  const [test, setTest] = useState(0);
  const [selectedItem, setSelectedItem] = useState();
  const [showAddModal, setShowAddModal] = useState(false);
  const [activeTab, setActiveTab] = useState("active");
  const [loading, setLoading] = useState(true);



  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await UserServices.getAllUser();
      const allUsers = response?.data?.data || [];

      const filteredActiveUsers = allUsers.filter(
        (user) => user.status === "active"
      );

      setActiveUsers(filteredActiveUsers);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [test]);

  useEffect(() => {
    if (activeTab === "active") {
      fetchUsers();
    }
  }, [activeTab]);

  // User search
  const filteredSearch = activeUsers.filter(user =>
    user?.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user?.role.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user?.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    activePag.current = 0;
  }, [searchTerm]);

  // Options for row selections
  const options = [
    { value: '5', label: '5' },
    { value: '10', label: '10' },
    { value: '20', label: '20' },
    { value: '50', label: '50' },
    { value: '100', label: '100' }
  ];

  // Pagination setup
  useEffect(() => {
    if (activeUsers.length > 0) {
      activePag.current = 0;
    }
  }, [activeUsers]);

  // Calculate total pages
  const pagination = Math.ceil(filteredSearch.length / sort);
  const onClick = (i) => {
    activePag.current = i;
    setTest(prev => prev + 1);
  };

  // Handle deleting user
  function handleDelete(e, user) {
    Swal.fire({
      title: 'Are you sure to delete?',
      text: "You will not be able to recover this User Again!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dd6b55',
      cancelButtonColor: '#aaa',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        UserServices.deleteUser(user._id).then(() => {
          setTest(user._id);
          Swal.fire('Deleted!', 'User has been deleted.', 'success');
        }).catch((error) => {
          Swal.fire('Error!', 'There was a problem deleting the user.', 'error');
        });
      }
    });
  }

  const handleStatusToggle = async (user) => {
    const newStatus = user.status === "active" ? "inactive" : "active";

    try {
      await UserServices.updateUser(user._id, {
        status: newStatus, // ✅ ONLY send required field
      });

      setTest(prev => prev + 1); // re-fetch users
      Swal.fire('Success!', `User status updated to ${newStatus}.`, 'success');
    } catch (error) {
      console.error(error);
      Swal.fire('Error!', 'There was a problem updating the user status.', 'error');
    }
  };


  const handleEditClick = (item) => {
    setSelectedItem(item); // Set the item to be edited
    setGridInsideModal(true); // Show modal
  };

  if (loading) {
    return (
      <Loader />
    );
  }


  return (
    <>
      <UseEditModal
        admin={selectedItem}
        show={gridInsideModal}
        test={setTest}
        handleClose={() => setGridInsideModal(false)}
      />

      <UserAddModel
        show={showAddModal}
        handleClose={() => setShowAddModal(false)}
        test={setTest}
      />


      {activeTab === "active" ? (
        <div className="row">
          <div className="col-xl-12">
            <div className="filter cm-content-box box-primary">
              <div className={`content-title`}>
                <div className="cpa">
                  <i className="fas fa-filter me-2"></i>Filter
                </div>
                <div className="tools">
                  <Link to="#" className={`SlideToolHeader ${open ? 'collapse' : 'expand'}`}
                    onClick={() => setOpen(!open)}
                  >
                    <i className="fas fa-angle-up"></i>
                  </Link>
                </div>
              </div>
              <Collapse in={open}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-3 col-xxl-6">
                        <input type="text"
                          className="form-control mb-xl-0 mb-3"
                          id="exampleFormControlInput1"
                          placeholder="Search by name, email, or role..."
                          value={searchTerm}
                          onChange={(e) => {
                            setSearchTerm(e.target.value);
                            activePag.current = 0;
                          }}
                        />
                      </div>
                      <div className="col-xl-3 col-xxl-6">
                        <Select
                          placeholder="Select row to display in User Table"
                          value={options.find(option => option.value === sort)}
                          onChange={(selectedOption) => {
                            setSort(Number(selectedOption.value));
                            activePag.current = 0;
                          }}
                          isSearchable={false}
                          options={options}
                          className="custom-react-select mb-3 mb-xxl-0"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
            <div className="filter cm-content-box box-primary">
              <div className="content-title d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">

                {/* Mobile Row 1: Left + Right */}
                <div className="d-flex justify-content-between align-items-center w-100 d-md-none">

                  {/* Left */}
                  <div className="cpa">
                    <i className="fa fa-list me-2" aria-hidden="true"></i>
                    Active User
                    <span className="badge bg-orange ms-2">
                      {filteredSearch.length}
                    </span>
                  </div>

                  {/* Right */}
                  <div className="tools">
                    <Link
                      to="#"
                      className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                      onClick={() => setOpen2(!open2)}
                    >
                      <i className="fas fa-angle-up"></i>
                    </Link>
                  </div>
                </div>

                {/* Desktop Left */}
                <div className="cpa text-center text-md-start d-none d-md-block">
                  <i className="fa fa-list me-2" aria-hidden="true"></i>
                  Active User
                  <span className="badge bg-orange ms-2">
                    {filteredSearch.length}
                  </span>
                </div>

                {/* Center Tabs */}
                <div
                  className="d-flex align-items-center flex-nowrap order-2 order-md-0 align-self-start"
                  style={{
                    background: "#f1f3f5",
                    padding: "5px",
                    borderRadius: "12px",
                    border: "1px solid #dee2e6",
                  }}
                >
                  <button
                    type="button"
                    onClick={() => setActiveTab("active")}
                    style={{
                      border: "none",
                      padding: "8px 18px",
                      borderRadius: "8px",
                      background:
                        activeTab === "active" ? "#0d6efd" : "transparent",
                      color:
                        activeTab === "active" ? "#fff" : "#495057",
                      fontSize: "13px",
                      fontWeight: "600",
                      cursor: "pointer",
                      transition: "0.2s ease",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Active Users
                  </button>

                  <button
                    type="button"
                    onClick={() => setActiveTab("inactive")}
                    className="ms-2"
                    style={{
                      border: "none",
                      padding: "8px 18px",
                      borderRadius: "8px",
                      background:
                        activeTab === "inactive" ? "#0d6efd" : "transparent",
                      color:
                        activeTab === "inactive" ? "#fff" : "#495057",
                      fontSize: "13px",
                      fontWeight: "600",
                      cursor: "pointer",
                      transition: "0.2s ease",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Pending Users
                  </button>
                </div>

                {/* Desktop Right */}
                <div className="tools d-none d-md-flex align-items-center justify-content-center">
                  <Link
                    to="#"
                    className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                    onClick={() => setOpen2(!open2)}
                  >
                    <i className="fas fa-angle-up"></i>
                  </Link>
                </div>

              </div>
              <div className="row me-0 me-md-3">
                <div className="col-12 d-flex w-100 justify-content-start justify-content-md-end ms-3 ms-md-0 me-md-4 mb-2">
                  <button
                    type="button"
                    className="btn btn-primary btn-sm d-flex align-items-center"
                    onClick={() => setShowAddModal(true)}
                  >
                    <i className="fas fa-plus me-2"></i>
                    Add New User
                  </button>
                </div>
              </div>

              <Collapse in={open2}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">


                    <div className="table-responsive">
                      <div id="content_wrapper" className="dataTables_wrapper no-footer">
                        <div style={{
                          overflowX: 'auto',
                          overflowY: 'auto',
                          maxHeight: '400px',
                          whiteSpace: 'nowrap',
                          position: 'relative',   // ✅ ADD THIS
                          zIndex: 0               // ✅ ADD THIS
                        }}>
                          <table
                            className="table table-bordered table-responsive-lg table-striped table-condensed flip-content"
                            id="active-users-data"
                          >
                            <thead
                              style={{
                                position: "sticky",
                                top: 0,
                                backgroundColor: "#fff",
                                zIndex: 1,              // ✅ LOWER than sidebar
                              }}
                            >
                              <tr>
                                <th>S.No</th>
                                <th>User Role</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Store</th>
                                <th>Mobile No.</th>
                                <th>Status</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {filteredSearch.length > 0 ? (
                                filteredSearch
                                  .slice(activePag.current * sort, (activePag.current + 1) * sort)
                                  .map((user, index) => (
                                    <tr key={index}>
                                      <td>{activePag.current * sort + index + 1}</td>
                                      <td>{user?.role}</td>
                                      <td>{user?.name}</td>
                                      <td>{user?.email}</td>
                                      <td className="scrollable-description">
                                        {user?.store?.length > 0
                                          ? user.store.map(store => store.name).join(', ')
                                          : 'No Stores'}
                                      </td>
                                      <td>{user?.mobileNo}</td>
                                      <td>
                                        <span
                                          onClick={() => handleStatusToggle(user)}
                                          style={{ cursor: 'pointer' }}
                                        >
                                          <i
                                            className={`fa ${user.status === 'active' ? 'fa-circle text-success' : 'fa-circle text-danger'}`}
                                            title={user.status === 'active' ? 'Active' : 'Inactive'}
                                          ></i>
                                        </span>
                                      </td>

                                      <td className="text-center">
                                        <button
                                          className="btn btn-primary btn-xs sharp"
                                          onClick={() => handleEditClick(user)} // Open modal on edit click
                                        >
                                          <i className="fa fa-pencil"></i>
                                        </button>
                                        <button className="btn btn-danger btn-xs sharp" onClick={(e) => { handleDelete(e, user) }}>
                                          <i className="fa fa-trash"></i>
                                        </button>
                                      </td>
                                    </tr>
                                  ))
                              ) : (
                                <tr>
                                  <td colSpan="7" className="text-center">No Active Users Found</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                          <div className="dataTables_info">
                            {filteredSearch.length > 0 ? (
                              <>
                                Showing {activePag.current * sort + 1} to{" "}
                                {Math.min(filteredSearch.length, (activePag.current + 1) * sort)} of{" "}
                                {filteredSearch.length} entries
                              </>
                            ) : (
                              <>Showing 0 to 0 of 0 entries</>
                            )}
                          </div>
                          {/* <div className="dataTables_paginate paging_simple_numbers">
                            <Link
                              className="paginate_button previous"
                              to="#"
                              onClick={() =>
                                activePag.current > 0 && onClick(activePag.current - 1)
                              }
                            >
                              <i className="fa fa-angle-double-left" aria-hidden="true"></i>
                            </Link>
                            <span>
                              {Array.from({ length: pagination }, (_, i) => (
                                <Link
                                  key={i}
                                  to="#"
                                  className={`paginate_button ${activePag.current === i ? "current" : ""}`}
                                  onClick={() => onClick(i)}
                                >
                                  {i + 1}
                                </Link>
                              ))}
                            </span>
                            <Link
                              className="paginate_button next"
                              to="#"
                              onClick={() =>
                                activePag.current < pagination - 1 && onClick(activePag.current + 1)
                              }
                            >
                              <i className="fa fa-angle-double-right" aria-hidden="true"></i>
                            </Link>
                          </div> */}

                          <Pagination activePage={activePag.current}
                            totalPages={pagination}
                            onPageChange={onClick} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
        </div>
      ) : (
        <UserPending
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          setShowAddModal={setShowAddModal}
        />
      )}
    </>
  );
};

export default User;
